var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSocialFacebook = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "var(--thc-icon-fill)",
  fillRule: "evenodd",
  d: "M26.28 46V25.93h6.49l.97-7.82h-7.46v-5c0-2.26.6-3.8 3.73-3.8H34v-7c-.69-.1-3.06-.31-5.81-.31-5.75 0-9.69 3.65-9.69 10.34v5.77H12v7.82h6.5V46z",
  clipRule: "evenodd"
})));
export { SvgSocialFacebook as ReactComponent };
export default new URL("/home/runner/work/motorway-seller-webapp/motorway-seller-webapp/node_modules/@motorway/mw-highway-code/src/assets/svgs/social-facebook.svg", import.meta.url).toString();